module.exports = __webpack_public_path__ + "static/img/banner_manage.892d3c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner/banner_manage.jpg
// module id = OWvR
// module chunks = 15